import { JhText } from "designPackages/textPackage";
import Image from "next/image";
import { useRouter } from "next/router";


const EmptyState = () => {
    const { query } = useRouter()
    const tabId = query.tabId
    const isReservedTab = tabId === "CREDITS_ON_HOLD"

    return (
        <div id="th-v2-empty-state-container" className={`${isReservedTab ? "min-h-[calc(100vh-145px)]" : "min-h-[calc(100vh-290px)]"} flex flex-col items-center justify-center p-4 gap-2.5 w-full h-full`}>
            <Image src={isReservedTab ? "/hire/transactionHistoryV2/no_reserved.png" : "/hire/transactionHistoryV2/no_transaction.png"} alt="no reserved credits" width={100} height={100} />
            <JhText variant="emphasis3" color="foreground" >
                {isReservedTab ? "No reserved credits found" : "No transactions made yet"}
            </JhText>
        </div>
    );
};

export default EmptyState;